<template>
    <div
        class="link"
        @mouseenter="store.setActiveNavItem(item.MainLink.Text)"
        @mouseleave="store.setActiveNavItem(null)">
        <span class="link__text">
            {{ item.MainLink.Text }}
            <span class="icon"></span>
        </span>
        <Transition name="fade-in-top">
            <div class="link__sub-items" v-if="store.getActiveNavItem === item.MainLink.Text">
                <a
                    class="sub-link"
                    :href="subitem.Url"
                    :target="subitem.Target"
                    :class="{ 'is-active': subitem.Active }"
                    v-for="(subitem, index) in item.SubItems"
                    :key="index">
                    {{ subitem.Text }}
                </a>
            </div>
        </Transition>
    </div>
</template>
<script setup lang="ts">
import { INavigationLinks } from '../../../interfaces/Navigation';
import { useDesktopNavStore } from '../store/desktop-nav.store';

const store = useDesktopNavStore();
defineProps<{
    item: INavigationLinks;
}>();
</script>
